/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'ktvgFMUtivQqBR8bWTkPMp.png': { uri: '/images/ktvgFMUtivQqBR8bWTkPMp.png' },
'kPbT5mZYDaqvyTMzNQUe25.png': { uri: '/images/kPbT5mZYDaqvyTMzNQUe25.png' },
'1H2kpDKiB6TUoMo61aHPey.png': { uri: '/images/1H2kpDKiB6TUoMo61aHPey.png' },
'fuqEYqcWkavJ3uKdEtJAZK.png': { uri: '/images/fuqEYqcWkavJ3uKdEtJAZK.png' },
'uxPky3uU6KTchfWigmyBWC.png': { uri: '/images/uxPky3uU6KTchfWigmyBWC.png' },
'8gRGxtAEueUfgR2uvB6JCw.png': { uri: '/images/8gRGxtAEueUfgR2uvB6JCw.png' },
'7mcnxFTGnJsCkwTruW8UFz.png': { uri: '/images/7mcnxFTGnJsCkwTruW8UFz.png' },
'smR57YnQCs3Cx1NrvrKzPK.png': { uri: '/images/smR57YnQCs3Cx1NrvrKzPK.png' },
'dnj9wDip2nQg63qAKeSyrZ.png': { uri: '/images/dnj9wDip2nQg63qAKeSyrZ.png' },
'5F13zyDMex3wmzcsPQpXji.png': { uri: '/images/5F13zyDMex3wmzcsPQpXji.png' },
'dMk5oDqPB5fGWPtpuav7Nb.png': { uri: '/images/dMk5oDqPB5fGWPtpuav7Nb.png' },
'rPAYPQguqA1qNWdww4HdWP.png': { uri: '/images/rPAYPQguqA1qNWdww4HdWP.png' },
'bXRXP4KdZsagzxgkWvaetE.png': { uri: '/images/bXRXP4KdZsagzxgkWvaetE.png' },
'fAaraR8spfV3LzB4xXxHqz.png': { uri: '/images/fAaraR8spfV3LzB4xXxHqz.png' },
'3jMw6c6J2TB2FwC4A8QJLZ.png': { uri: '/images/3jMw6c6J2TB2FwC4A8QJLZ.png' },
'ubRp3iuUGkjy9fxD7uJuFV.png': { uri: '/images/ubRp3iuUGkjy9fxD7uJuFV.png' },
'1kh8pkLmPqidfWhB1xRtah.png': { uri: '/images/1kh8pkLmPqidfWhB1xRtah.png' },
'6qdwgjn1ZGE4ZAJRU5a79T.png': { uri: '/images/6qdwgjn1ZGE4ZAJRU5a79T.png' },
'86Uq8Twj9o1zSsmu4ieWVo.png': { uri: '/images/86Uq8Twj9o1zSsmu4ieWVo.png' },
'vinWbxXgQUgWDpJJeFATSf.png': { uri: '/images/vinWbxXgQUgWDpJJeFATSf.png' },
'wk9KBJESsJrWzzTiyro9MC.png': { uri: '/images/wk9KBJESsJrWzzTiyro9MC.png' },
'qxX4bzF8X6aaFptiSYayn5.png': { uri: '/images/qxX4bzF8X6aaFptiSYayn5.png' },
'83xkXYYf9L5cqUKqMdDTim.png': { uri: '/images/83xkXYYf9L5cqUKqMdDTim.png' },
'mPtoyuFM8BgJ8LurfJWDbt.png': { uri: '/images/mPtoyuFM8BgJ8LurfJWDbt.png' },
'4EFYFJx3DRACw1msYNejxe.png': { uri: '/images/4EFYFJx3DRACw1msYNejxe.png' },
'khJY8JpKd98TWmTaf5xNja.png': { uri: '/images/khJY8JpKd98TWmTaf5xNja.png' },
'1LJaTshWjpBhHVCCg4CXBt.png': { uri: '/images/1LJaTshWjpBhHVCCg4CXBt.png' },
'3dKSznzyrM2HXJ2REhGvhi.png': { uri: '/images/3dKSznzyrM2HXJ2REhGvhi.png' },
'6oEQqJJY5EtE8ZnDEguafq.png': { uri: '/images/6oEQqJJY5EtE8ZnDEguafq.png' },
'hq91wsPJdw5tF1yxurensY.png': { uri: '/images/hq91wsPJdw5tF1yxurensY.png' },
'tidAdhfN13meV4CGVmDy4J.png': { uri: '/images/tidAdhfN13meV4CGVmDy4J.png' }
}

export default imageStaticSourcesByFileName
